import api from "../services/api";

export const getSales = async (from, to) => (await api.get('/admin/sales', { params: { from, to } })).data;
export const getSubscriptions = async () => (await api.get('/admin/subscriptions')).data;
export const syncSales = async () => (await api.post('/admin/sales/sync')).data;
